export default __webpack_public_path__ + "static/media/marketing.f629aa39.jpg";